import styled from 'styled-components';
import { INDEX_CONTAINER_WIDTH } from '../styles/constants';

export const Main = styled.main`
  transition: opacity 0.2s ease-in-out;
  flex-direction: row;
  width: calc(100% - 30px);
  margin: 0 auto !important;
  column-gap: 16px;
  position: relative;

  @media (min-width: 768px) {
    display: flex !important;
    flex-wrap: wrap;
  }

  @media (min-width: 768px) {
    width: calc(100% - 48px);
    max-width: ${INDEX_CONTAINER_WIDTH};
  }

  @media (min-width: 1280px) {
    width: 1240px;
    max-width: ${INDEX_CONTAINER_WIDTH};
  }

  &.openx-ui-main-collapsed {
    margin: 16px auto !important;
  }

  .openx-ui-filters-container {
    width: 100%;
    min-height: 44px;
    margin: 0 auto 20px;
  }

  .openx-ui-filters {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background: transparent;
    white-space: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .openx-ui-filters::-webkit-scrollbar {
    display: none;
  }

  .container-item-horizontal {
    margin-right: 8px;
  }

  .multilistbox [role='option'] {
    height: 20px;
    line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};

    span {
      height: 20px;
      line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};
    }
  }

  .container-item.container-item-horizontal .container-controls {
    padding: 0;
  }

  .container-item.container-item-horizontal .container-controls li {
    padding: 0 20px;
  }
`;
